import { useQuery } from '@apollo/react-hooks';

import { fetchDatasets } from 'graphql/queries/datasets';

export const FetchDataset = () => {
  const { data } = useQuery(fetchDatasets);

  return data;
};
